export default {
  independentMarketing: {
    common: {
      requestFailed: 'Falha na solicitação de interface',
      hintSelect: 'Selecione',
      hintInput: 'Digitar',
      submit: 'Enviar',
      cancel: 'Cancelar',
      confirm: 'OK',
    },
    agreement: {
      title: 'Contrato de Registro de Revendedor Independente Autel',
      nextBtn: 'Próximo',
      getAgreementFailed: 'Falha ao obter o conteúdo do contrato.',
    },
    successPage: {
      title:
        'As informações da sua inscrição foram enviadas com sucesso e os resultados da análise serão enviados para o seu e-mail $1 em até 15 dias úteis. Por favor, verifique sua caixa de entrada para mais informações.',
      subTitle: 'Retorne à página inicial após $1 segundo(s).',
    },
    applyTitle:
      'Você está se inscrevendo para se tornar um revendedor independente da Autel. Por favor preencha as seguintes informações com precisão:',
    companyName: 'Nome da empresa',
    companyTax: 'VAT ID',
    userCountry: 'País',
    legalPerson: 'Consultor jurídico',
    contactEmail: 'Email de contato',
    contactEmailTips:
      'Este endereço de e-mail será seu contato no e-mail com o resultado da avaliação. Assim que a revisão for aprovada, ela também será usada como nome de conta de login para o sistema de gerenciamento de revendedores independentes.',
    corporateIdentity: 'ID do consultor jurídico',
    uploadTips: 'JPG, JPEG, PNG, PDF (não maior que 20 MB)',
    businessLicense: 'Alvará de funcionamento',
    emailErrorTips: 'Insira um e-mail válido.',
    uploadPic: 'Enviar imagens',
    picMaxLimit: 'O tamanho máximo da imagem é 20 MB. Selecione novamente.',
  },
};
